<div
  class="cdw-table-container"
  [class]="tableClass"
  [ngClass]="styleClass"
  [style.border-radius]="showBorderRadius ? '8px' : ''"
  [style.box-shadow]="showBoxShadow ? '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)' : ''"
>
  <table class="cdw-table">
    <thead>
      <tr>
        <th
          *ngFor="let column of columns"
          [class]="getHeaderClasses(column)"
          [style.width]="column.width"
          [style.background-color]="headerBgColor"
          [style.border-bottom]="'2px solid ' + borderColor"
        >
          {{ column.header }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let row of data; let i = index"
        [class]="rowClass"
        [style.background-color]="i % 2 === 0 ? alternateRowBgColor : alternateRowBgColor"
      >
        <td
          *ngFor="let column of columns"
          [class]="getCellClasses(column)"
          [style.border-bottom]="'1px solid ' + borderColor"
        >
          {{ getCellValue(row, column.field) }}
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Empty state -->
  <div *ngIf="!data || data.length === 0" class="empty-state">
    <p>No data available</p>
  </div>
</div>
